import config from '../../package.json'

export const WEB_VERSION = config.version
